// features/auth/api/auth.api.js
// Capa de API para autenticación.

import { api } from '../../../api/client';

export const authApi = {
  /**
   * Inicia sesión y retorna { token, user, ... }
   * @param {{ username: string, password: string }} credentials
   */
  login: (credentials) =>
    api.post('/auth/login', credentials),

  /**
   * Solicita recuperación de contraseña por correo
   * @param {{ email: string }} data
   */
  forgotPassword: (data) =>
    api.post('/auth/forgot-password', data),

  /**
   * Restablece contraseña con token de recuperación
   * @param {{ token: string, newPassword: string }} data
   */
  /**
   * Valida si el token de recuperación aún es válido (sin consumirlo)
   * @returns { status: 'VALID' | 'EXPIRED' | 'INVALID' }
   */
  validateResetToken: (token) =>
    api.get(`/auth/validate-reset-token?token=${encodeURIComponent(token)}`),

  resetPassword: (data) =>
    api.post('/auth/reset-password', data),
};
